var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMailSolid = function SvgIconMailSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.501.5h15c.46 0 .834.373.834.833v13.334c0 .46-.373.833-.834.833h-15a.833.833 0 0 1-.833-.833V1.333c0-.46.373-.833.833-.833m7.55 7.236L3.708 3.198 2.63 4.468l6.433 5.463 6.318-5.468-1.09-1.26z"
  })));
};
export default SvgIconMailSolid;